<template>
  <div class="home-container">
    <div class="image-container">
      <img
          src="https://masticando-cdn.s3.eu-west-1.amazonaws.com/logo-435x435.png"
          alt="Masticando"
          class="home-image"
      >
    </div>
    <div class="slogan-container">
      <h1>Masticativi acquistabili esclusivamente da tecnici del settore</h1>
    </div>
    <div class="reseller-button-container">
      <router-link to="/dove-acquistare" class="primary-link">dove acquistare</router-link>
    </div>
    <div class="background-container primary-box">
      <h2>Il supporto educativo che fa la differenza</h2>
      <p>Scopri la nostra selezione di masticativi naturali, studiati per favorire il benessere, l’equilibrio, l’apprendimento e la riduzione degli indici di stress del cane.</p>
    </div>
    <div class="card-deck" id="products-deck">
      <v-card
          class="card"
          v-for="product in products"
          :key="product.id"
          :id="product.id"
      >
        <router-link :to="`/prodotto/${product.id}/${product.slug}`">
          <v-img :src="product?.img?.formats?.small?.url" :alt="product.name" width="100%" eager>

          </v-img>

          <div class="card-description">
            <v-card-title>{{product.name}}</v-card-title>
            <v-card-subtitle v-html="product.abstract"></v-card-subtitle>
          </div>
        </router-link>
      </v-card>
    </div>
    <div class="background-container primary-box">
      <h2>Perché Masticando?</h2>
      <p>Masticando nasce con un obiettivo preciso: offrire ai professionisti del settore cinofilo prodotti funzionali per il processo di apprendimento del canee per le attività di riduzione degli indici di stress.</p>
      <p>I nostri masticativi sono il frutto di anni di esperienza e collaborazione con tecnici del settore cinofilo e differenti veterinari (clinici, nutrizionisti, comportamentalisti ecc..).<br>
        Sono veri e propri strumenti di lavoro, progettati per supportare i professionisti nel percorso di educazione, di recupero comportamentale e di riduzione degli indici di stress; studiati per implementare gli indicatori di benessere del cane.</p>
      <p>Garantiamo un altissima qualità con pezzature studiate per adattarsi a qualsiasi tipologia di soggetto, visto che i nostri prodotti sono stati testati su migliai di cani e che, grazie all’osservazione costante, ci ha permesso di sviluppare masticativi che nessun cane normo-comportamentale abbia mai rifiutato, anche se valutato in presenza di situazioni di stress.</p>
      <p>Ora puoi offrire ai tuoi clienti un prodotto al 100% artigianale e italiano, senza additivi, completamente naturale. Trattalo come indicato nell'etichetta e nell'apposita didascalia poichè, come tutti i prodotti artigianali ha una durata limitata e alcuni di questi necessitano di essere conservati ad apposite temperature, ma non temere la shelf life (durata del prodotto) permette che venga consumato nel tempo adeguato.</p>
      <p>In questo progetto abbiamo messo competenza, professionalità e un infinita passione, ci siamo affidati a tecnici competenti e al promotore della masticazione. Siamo certi che, come professionista del settore, saprai scegliere il masticativo giusto per ogni caso e ogni cane, supportando il suo percorso educativo in modo efficace.</p>
      <p>Avrai a disposizione oltre ad un supporto tecnico ed una consulenza online, una breve descrizione di ogni prodotto con i dovuti consigli sul suo utilizzo.</p>
      <p>Grazie per la fiducia e il tuo lavoro, accomunati dalla passione che condividiamo per il mondo cinofilo.</p>
      <h3>Buon lavoro a tutti!</h3>
      <p>E permetteteci un piccolo slogan: …<strong>#EDUCAMASTICANDO</strong>...!!<br>
        Godetevi questa classe di comunicazione masticando:</p>
    </div>
    <div class="image-box">
      <!--      <img :src="photo?.formats?.large?.url" alt="food" style="width: 100%; height: auto;">-->
      <video autoplay muted loop class="home-video">
        <source src="https://masticando-cdn.s3.eu-west-1.amazonaws.com/home-video.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="background-container primary-box">
      <h1>Contattaci</h1>
      <p>Hai bisogno di informazioni o vuoi scoprire dove acquistare? Siamo qui per aiutarti!<br>
        Per qualsiasi domanda, contattaci via email a <a href="mailto:info@masticando.com">info@masticando.com</a>. Ti risponderemo al più presto!</p>
      <br>

      <p>
        <strong>Masticando di Carella Valentina</strong><br>
        <strong>P.IVA</strong>: 03064600343<br>
        <strong>Sede legale</strong>: strada Riano n 11/a 43013 Langhirano (PR)
      </p>
    </div>
  </div>
</template>

<script>
import {updateMetaInfo} from "@/middleware/metaUpdater";
import apiService from "@/services/ApiService";

export default {
  name: 'HomeHome',
  methods: {
    async getData() {
      try {
        let products = await apiService.getProducts();
        products = products.sort((a, b) => {
          const nameA = a.order ?? 99;
          const nameB = b.order ?? 99;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        this.products = products;
      } catch (e) {
        console.error(e);
      }
    }
  },
  data() {
    return {
      products: [],
      language: "IT"
    }
  },
  props: {
  },
  computed: {
    metaInfo() {
      return {
        properties: [
          {property: 'og:title', content: "Masticando"},
          {property: 'og:description', content: "Masticando nasce con un obiettivo preciso: offrire ai professionisti del settore cinofilo prodotti funzionali per il processo di apprendimento del cane e per le attività di riduzione degli indici di stress."},
          {property: 'og:image', content: "https://masticando-cdn.s3.eu-west-1.amazonaws.com/logo-435x435.png"},
          {property: 'og:url', content: "https://masticando.com"},
          {property: 'og:type', content: "website"},
        ]
      }
    }
  },
  async beforeMount() {
    updateMetaInfo(this.metaInfo);
    await this.getData();
  },
  created(){
    const fullPath = this.$route.fullPath;
    if(fullPath.includes("#products-deck")){
      const selector = fullPath.includes('#products-deck-id-')
          ? fullPath.split('#products-deck-id-')[1]
          : 'products-deck';
      //const selector = 'products-deck';

      setTimeout(() => {
        document.getElementById(selector).scrollIntoView({behavior: "smooth", block: "start"});
      }, 250);

      this.$router.replace('/');

    }
  }
}
</script>


<style lang="scss">
@import '../style/_variables.scss';
.home-container {
  //background-color: rgba($primary-color,0.1);
  //-webkit-box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
  //box-shadow: 0px 0px 5px 5px rgba($primary-color,0.64);
  background-color: $secondary-background-color;
  //border-radius: 5px;
  //padding: 0 5px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .home-video {
    max-width: 1000px;
    width: 100%;
  }
  .image-box {
    margin-top: 20px;
  }
  .avatar {
    margin-top: 10px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 3px 3px rgba($tertiary-color,0.64);
  }
  .reseller-button-container {
    padding-top: 5px;
    padding-bottom: 5px;
    a {
      margin-top: 10px;
      cursor: pointer;
      font-size: 1rem;
      padding: 10px 20px;
      color: $text-color;
      &:hover {
        opacity: 0.8;
      }
    }

  }
  .slogan-container {
    h1{
      color:transparent;
      background-clip: text;
      background-image: $primary-gradient;
      font-optical-sizing: auto;
      padding: 10px;
      font-family: $header-font;
      font-size: 2.3rem;
      line-height: 2.3rem;
      font-weight: 550;
      text-transform: uppercase;
    }
  }
  .image-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .background-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: blur(5px);
      padding: 5px;
    }

    .home-image {
      position: relative;
      z-index: 1;
      display: block;
      width: 100%;
    }
  }
  .search-button-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 5px;
    .v-btn {
      width: 220px;
    }
  }
  .search-link {
    font-weight: 700;
    cursor: pointer;
    text-decoration: underline;
    text-transform: uppercase;
  }
  p {
    margin-top: 5px;
    margin-bottom: 20px;
    font-family: $font-base;
    font-weight: 500;
    a {
      font-weight: 700;
      color: $primary-contrast-color;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .secondary-color {
    color: $secondary-color;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: $header-font;
  }
  h2 {
    margin-top: 20px;
    font-family: $header-font;
  }
  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-family: $header-font;

    a {
      font-weight: 700;
      color: $primary-contrast-color;
      cursor: pointer;
      text-decoration: underline;
      &.reseller-link {
        font-weight: 500;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          font-weight: 700;
        }
      }
    }
  }
  .background-container {
    width: 100%;
    margin-top: 20px;
    padding: 20px;
    .search-container {
      width: 100%;
      margin-top: 20px;
    }

  }

}

@media (max-width: 700px) {
  .home-container {
    width: 100%;
    min-height: $main-min-height;
    margin: 0;
    border-radius: 5px;
    .slogan-container {
      h1 {
        font-size: 1.7rem;
        line-height: 1.7rem;
      }
    }

    .slogan-container {
      padding-left: 0;
      padding-right: 0;
    }
    .image-container {
      .home-image {
        width: 65%;
      }
    }
  }
}
</style>
